import { FC } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Box } from '@mui/material'
import { PaycodeForm } from './PaycodeForm'
import { PaperComponent } from 'shared/ui/draggable/Draggable'
import { usePaycodeForm } from 'hooks/paycodes/usePaycodeForm'
import { Paycode } from 'repository/timekeeper/@types/PaycodeModel'
import { useTranslation } from 'react-i18next'
import { AlertCustom } from 'shared/ui/alert/AlertCustom'
import { PaycodeDelete } from 'components/dialog/paycodes/PaycodeDelete'
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    open: boolean
    onClose: () => void
    rows: Paycode[]
    selectedRow: Paycode[]
    reloading: () => void
    mode: 'add' | 'edit' | 'delete' | 'info'
}

export const PaycodeDialog: FC<Props> = ({ open, mode, onClose, rows, selectedRow, reloading }) => {
    const { t } = useTranslation();
    const form = usePaycodeForm({ rows, onClose, reloading, mode, selectedRow, open })


    return (
        <Dialog open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    return;
                }
                if (mode === 'delete') {
                    onClose()
                } else {
                    form.detectChanges();
                }
            }}
            PaperComponent={PaperComponent}
            maxWidth="sm"
            fullWidth
            aria-labelledby="draggable-dialog-title"
            aria-describedby="draggable-alert-dialog-description"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {mode === 'edit' ? t('settings.paycodes.table.modals.edit.title') : t('settings.paycodes.table.modals.add.title')}
            </DialogTitle>

            <IconButton
                aria-label="close"
                onClick={() => {
                    if (mode === 'delete') {
                        onClose()
                    } else {
                        form.detectChanges()
                    }
                }}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>

            <Box sx={{ top: 0, zIndex: 10, pb: 1 }}>
                {form.alert && (
                    <AlertCustom alerts={form.alert} setAlerts={form.setAlert} closeForm={form.cleanForm} t={t} />
                )}
            </Box>

            <DialogContent dividers>
                {
                    mode === 'delete' ? (
                        <PaycodeDelete open={open} setOpen={form.setAlert} selectedRow={selectedRow} reloading={reloading} />
                    ) : (
                        <PaycodeForm form={form} mode={mode} />
                    )
                }
            </DialogContent>

            {mode !== 'delete' && (
                <DialogActions>
                    <Button variant='contained' color="error" onClick={form.cleanForm}>{t('general.buttons.cancel')}</Button>
                    <Button variant='contained' color='primary' onClick={form.handleSubmit} disabled={form.disabled}>
                        {mode === 'edit' ? t('settings.paycodes.table.modals.edit.buttons.save') : t('general.buttons.save')}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    )
}